import {Injectable} from "@angular/core";
import {CanActivate, Router, UrlTree} from "@angular/router";
import {AuthenticationService} from "../services/services/authentication.service";

@Injectable({
	providedIn: "root",
})
export class MyProfilesRedirectGuard implements CanActivate {
	constructor(
		private authService: AuthenticationService,
		private router: Router,
	) {}

	async canActivate(): Promise<UrlTree> {
		const user = await this.authService.getApplicationUser();
		const employeeId = user?.employee?.id;
		return this.router.createUrlTree(["/my-profiles", employeeId]);
	}
}
